<template>
  <div class="chatroom-container bg-light h-100 d-flex flex-column" :class="{'fullscreen-mode': fullscreen}">
    <div class="py-1 px-4 d-flex w-100 align-items-center" style="border-bottom: 1px solid #ccc">
      <h4 class="bold flex-grow-1 d-flex align-items-center">
        <span>Mes conversations</span>
        <span class="mx-2"><i class="fa fa-caret-right"></i> </span>
        <span v-if="selectedChatroom == null">Choisir une conversation</span>
        <span v-else class="flex-grow-1">
          <input type="text" v-model="selectedChatroom.chatroom_name" class="form-control-title w-100" :placeholder="chatroomPlaceholderTitle(selectedChatroom)" @change="saveTitleChange">
        </span>
      </h4>
      <div class="ml-4" v-if="selectedChatroom != null && (options.canInviteInOtherChatrooms || selectedChatroom.chatroom_creation_user_id == user.user_id)">
        <a href="javascript:;" @click="popupInviteUser" title="Inviter des utilisateurs"><i class="icon-user-follow"></i></a>
      </div>
      <div class="ml-4" v-if="selectedChatroom != null">
        <a href="javascript:;" @click="popupConfirmLeave(selectedChatroom)" title="Quitter la conversation"><i class="icon-logout"></i></a>
      </div>
      <div class="ml-4" v-if="selectedChatroom != null && selectedChatroom.chatroom_creation_user_id == user.user_id">
        <a href="javascript:;" class="font-red" @click="popupConfirmDelete(selectedChatroom)" title="Supprimer la conversation"><i class="icon-trash"></i></a>
      </div>
      <div class="ml-4">
        <a v-if="fullscreen" href="javascript:;" @click="fullscreen = false" title="Quitter le mode plein-écran"><i class="icon-size-actual"></i></a>
        <a v-else href="javascript:;" @click="fullscreen = true"><i class="icon-size-fullscreen" title="Mode plein-écran"></i></a>
      </div>
    </div>

    <div class="chatroom-panels">

      <!-- Panneau de gauche -->
      <div class="chatroom-left-panel">

        <!-- Barre de recherche -->
        <div class="px-4 py-2" style="border-bottom: 1px solid #ccc">
          <input type="text" v-model="filters.query" placeholder="Rechercher des conversations..." class="form-control input-sm">
        </div>

        <!-- Démarrer un chatroom -->
        <div class="px-4 py-2" style="border-bottom: 1px solid #ccc" v-if="options.canCreateChatrooms">
          <button class="btn btn-sm blue w-100" @click="prepareAddingForm">Démarrer une conversation <i class="fa fa-plus"></i></button>
        </div>

        <!-- Liste de chatrooms -->
        <div class="chatroom-list-wrapper">
          
          <div v-if="invitedChatrooms.length > 0">
            <div class="py-2 text-center" style="border-bottom: 1px solid #ccc">
              Invitations aux conversations
            </div>
            <div v-for="(chatroom, index) in invitedChatrooms" :key="index" class="chatroom-list-item is-unread" :class="{'selected': selectedChatroom != null && selectedChatroom.chatroom_id == chatroom.chatroom_id}" @click="selectChatroom(chatroom, true)">
              <div class="py-2 pl-4">
                <div v-if="chatroom.participants.length == 1" class="chatroom-item-icon" :style="{'background-color': chatroom.participants[0].user_background_color}">{{chatroom.user_initials}}</div>
              </div>
              <div class="w-100 py-2">
                <div class="chatroom-item-title px-4" v-if="chatroom.chatroom_name == ''">
                  {{ chatroomPlaceholderTitle(chatroom) }}
                </div>
                <div class="chatroom-item-title px-4" v-else>
                  {{ chatroom.chatroom_name }}
                </div>
                <div class="chatroom-item-last-message px-4">Attente de réponse...</div>
              </div>
              <div class="read-indicator"></div>
            </div>
          </div>
          
          <div v-if="chatroomFilteredList.length > 0">
            <div class="py-2 text-center" style="border-bottom: 1px solid #ccc">
              Conversations actives
            </div>
            <div v-for="(chatroom, index) in chatroomFilteredList" :key="index" class="chatroom-list-item" :class="{'is-unread': chatroom.chatroom_unread, 'selected': selectedChatroom != null && selectedChatroom.chatroom_id == chatroom.chatroom_id}" @click="selectChatroom(chatroom, false)">
              <div class="py-2 pl-4">
                <div v-if="chatroom.participants.length == 1" class="chatroom-item-icon" :style="{'background-color': chatroom.participants[0].user_background_color}">{{chatroom.user_initials}}</div>
                <div v-else-if="chatroom.participants.length == 2" class="chatroom-item-icon" :style="{'background-color': otherParticipant(chatroom).user_background_color}">{{otherParticipant(chatroom).user_initials}}</div>
                <div v-else class="chatroom-item-icon"><i class="fa fa-users"></i></div>
              </div>
              <div class="w-100 py-2">
                <div class="chatroom-item-title px-4" v-if="chatroom.chatroom_name == ''">
                  {{ chatroomPlaceholderTitle(chatroom) }}
                </div>
                <div class="chatroom-item-title px-4" v-else>
                  {{ chatroom.chatroom_name }}
                </div>
                <div class="chatroom-item-last-message px-4"><b>{{chatroom.chatroom_last_message_user_name}}</b> <span v-html="advancedFormat(chatroom.chatroom_last_message_content)"></span></div>
              </div>
              <div class="read-indicator"></div>
            </div>
          </div>

        </div>

      </div>

      <!-- Panneau de droite -->
      <div class="chatroom-right-panel">

        <chatroom-feed v-if="selectedChatroom != null"
          :chatroom="selectedChatroom"
          :user="user"
          :isInvite="chatroomIsInvite"
          ref="chatroom-feed"
          @inviteAccepted="inviteAccepted"
          @inviteRejected="inviteRejected"
          @messageReceived="messageReceived"
        />

      </div>

    </div>

    <chatroom-invite-form 
      v-if="selectedChatroom != null" 
      :chatroom="selectedChatroom" 
      ref="chatroom-invite-form"
      @confirm="inviteUser"
    />

    <chatroom-add-form :form="addingForm" ref="chatroom-add-form" @confirm="confirmAddingForm" />

  </div>
</template>

<script>
import toastr from 'toastr';
import ChatroomFeed from './ChatroomFeed.vue'
import ChatroomInviteForm from './ChatroomInviteForm.vue';
import ChatroomAddForm from './ChatroomAddForm.vue';

export default {
  components: {
    ChatroomFeed,
    ChatroomInviteForm,
    ChatroomAddForm,
  },
  name: "chatroom",
  props: {
    user: {
      type: Object,
      required: true
    },
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      selectedChatroom: null,
      fullscreen: false,
      filters: {
        query: ""
      },
      addingForm: null,
      joinedChatrooms: [],
      invitedChatrooms: [],
      refreshCounter: 0,
      chatroomIsInvite: false,
      options: {
        canCreateChatrooms: false
      },
    }
  },
  computed: {
    chatroomFilteredList() {
      this.refreshCounter;
      this.filters.query;

      let that = this;
      return this.joinedChatrooms.filter((chatroom) => {
        return chatroom.chatroom_name.toLowerCase().indexOf(that.filters.query.toLowerCase()) !== -1;
      })
    },
    chatroomPlaceholderTitle() {
      return (chatroom) => {
        return chatroom.participants.map(p => p.user_name).join(", ");
      };
    },
    nbAlerts() {
      this.refreshCounter;
      let count = this.invitedChatrooms.length;
      count += this.joinedChatrooms.filter(c => c.chatroom_unread).length;
      return count;
    },
    otherParticipant() {
      return (chatroom) => {
        return chatroom.participants.find(p => p.user_id != this.user.user_id);
      };
    }
  },
  created () {
    for (const key in this.params) {
      if (Object.hasOwnProperty.call(this.params, key)) {
        const element = this.params[key];
        this.options[key] = element;
      }
    }
  },
  mounted () {
    this.fetchJoinedChatrooms();
    this.fetchInvitedChatrooms();
    this.registerWebsocketListeners();
  },
  methods: {
    messageReceived() {
      this.refreshCounter++;
    },
    async fetchJoinedChatrooms() {
      try {
        let results = await $.get(`${window.baseUrl}chatroom/retrieve-joined-chatrooms`);
        for (const result of results) {
          result.messages = [];
        }
        this.joinedChatrooms = results;
      } catch (ex) {
        toastr.error("Une erreur s'est produite", ex.message)
      }
    },
    async fetchInvitedChatrooms() {
      try {
        let results = await $.get(`${window.baseUrl}chatroom/retrieve-invited-chatrooms`);
        for (const result of results) {
          result.messages = [];
        }
        this.invitedChatrooms = results;
      } catch (ex) {
        toastr.error("Une erreur s'est produite", ex.message)
      }
    },
    prepareAddingForm() {
      this.addingForm = {
        chatroom_name: "",
        participants: [
          this.user
        ]
      }

      this.$nextTick(() => {
        this.$refs["chatroom-add-form"].open();
      })
    },
    async confirmAddingForm() {
      this.addingForm.chatroom_name = this.addingForm.chatroom_name.trim();

      try {
        let result = await $.post(`${window.baseUrl}chatroom/create`, this.addingForm);

        this.joinedChatrooms.push(result);
        this.addingForm = null;
        this.refreshCounter++;
        this.$refs["chatroom-add-form"].dismiss();
      } catch (ex) {
        toastr.error("Une erreur s'est produite", ex.message)
      }
    },
    cancelAddingForm() {
      this.addingForm = null;
    },
    selectChatroom(chatroom, isInvite) {
      this.chatroomIsInvite = isInvite;
      this.selectedChatroom = chatroom;
      this.selectedChatroom.messages = [];
      this.$nextTick(async () => {
        if(!isInvite){
          await this.$refs["chatroom-feed"].fetchMessages();
          this.$refs["chatroom-feed"].scrollToBottom();
          this.$refs["chatroom-feed"].joinWebsocketRoom();
        }
      })
    },
    async saveTitleChange() {
      try {
        let result = await $.post(`${window.baseUrl}chatroom/updatename`, {chatroom_id: this.selectedChatroom.chatroom_id, chatroom_name: this.selectedChatroom.chatroom_name});
        this.refreshCounter++;
        this.$refs["chatroom-invite-form"].dismiss();
      } catch (ex) {
        toastr.error(ex.responseJSON.message, "Une erreur s'est produite")
        console.error(ex);
      }
    },
    popupInviteUser() {
      this.$refs["chatroom-invite-form"].open();
    },
    async inviteUser(user) {
      try {
        let result = await $.post(`${window.baseUrl}chatroom/invite`, {chatroom_id: this.selectedChatroom.chatroom_id, user_id: user.user_id});
        this.refreshCounter++;
        this.$refs["chatroom-invite-form"].dismiss();
        toastr.success(`Invitation envoyé à ${user.user_name} avec succès!`);
      } catch (ex) {
        toastr.error(ex.responseJSON.message, "Une erreur s'est produite")
      }
    },
    inviteAccepted() {
      let ix = this.invitedChatrooms.findIndex(c => c.chatroom_id == this.selectedChatroom.chatroom_id);
      this.joinedChatrooms.unshift(this.invitedChatrooms[ix]);
      this.selectChatroom(this.invitedChatrooms[ix], false);
      this.invitedChatrooms.splice(ix,1);
      toastr.info(`Vous avez accepté de joindre la conversation.`);
    },
    inviteRejected() {
      let ix = this.invitedChatrooms.findIndex(c => c.chatroom_id == this.selectedChatroom.chatroom_id);
      this.invitedChatrooms.splice(ix,1);
      this.selectedChatroom = null;
      toastr.info(`Vous avez refusé de joindre la conversation.`);
    },
    popupConfirmLeave(chatroom) {
      let that = this;

      if(chatroom.chatroom_creation_user_id == this.user.user_id) {
        toastr.error("Vous ne pouvez pas quitter votre propre conversation.");
        return;
      }

      bootbox.dialog({
        title: "Quitter la conversation",
        message: `Voulez-vous vraiment quitter cette conversation?`,
        buttons: {
          confirm: {
            label: "Quitter",
            className: "red",
            callback: async function() {
              let result = await that.leaveUser(chatroom);
              return result;
            }
          },
          cancel: {
            label: "Annuler",
            className: "secondary",
            callback: function() {},
          }
        }
      })
    },
    async leaveUser(chatroom) {
      try {
        let result = await $.post(`${window.baseUrl}chatroom/leave`, { chatroom_id: this.selectedChatroom.chatroom_id });

        let ix = this.joinedChatrooms.findIndex(c => c.chatroom_id == chatroom.chatroom_id);
        this.joinedChatrooms.splice(ix,1);

        this.selectedChatroom = null;

        this.refreshCounter++;
        toastr.info(`Vous avez quitté la conversation.`);
        return true;
      } catch (ex) {
        toastr.error("Une erreur s'est produite", ex.message)
        return false;
      }
    },
    popupConfirmDelete(chatroom) {
      let that = this;

      if(chatroom.chatroom_creation_user_id != this.user.user_id) {
        toastr.error("Vous devez être le créateur de la conversation pour la supprimer.");
        return;
      }

      bootbox.dialog({
        title: "Supprimer la conversation",
        message: `Voulez-vous vraiment et définitivement supprimer cette conversation?`,
        buttons: {
          confirm: {
            label: "Supprimer la conversation",
            className: "red",
            callback: async function() {
              let result = await that.deleteChatroom(chatroom);
              return result;
            }
          },
          cancel: {
            label: "Annuler",
            className: "secondary",
            callback: function() {},
          }
        }
      })
    },
    async deleteChatroom(chatroom) {
      try {
        let result = await $.post(`${window.baseUrl}chatroom/delete`, { id: this.selectedChatroom.chatroom_id });

        let ix = this.joinedChatrooms.findIndex(c => c.chatroom_id == chatroom.chatroom_id);
        this.joinedChatrooms.splice(ix,1);

        this.selectedChatroom = null;

        this.refreshCounter++;
        toastr.info(`Vous avez supprimé la conversation.`);
        return true;
      } catch (err) {
        console.error(err);
        toastr.error(err.responseJSON.message, "Une erreur s'est produite")
        return false;
      }
    },
    registerWebsocketListeners(){
      let that = this;

      WS.join("chatrooms.invites", (data) => {
        if(data.chatroom != null && data.invited_user_id == that.user.user_id){
          that.invitedChatrooms.push(data.chatroom);
          that.refreshCounter++;
        }
      });
      
      WS.join("chatrooms.message.create.notify", (data) => {
        if(data.chatroom_id != null){
          let chatroom = that.joinedChatrooms.find(c => parseInt(c.chatroom_id) == data.chatroom_id);
          if(chatroom != null){
            chatroom.chatroom_unread = true;
          }
          that.refreshCounter++;
        }
      });
      
      WS.join(`chatrooms.peruser.${this.user.user_id}`, (data) => {
        if(data.action != null){
          let chatroom = null;
          let ix = null;

          switch(data.action) {
            case "updatename":
              chatroom = this.joinedChatrooms.find(c => c.chatroom_id == data.chatroom_id);
              if(chatroom == null) {
                chatroom = this.invitedChatrooms.find(c => c.chatroom_id == data.chatroom_id);
              }

              if(chatroom != null) {
                chatroom.chatroom_name = data.name;
                this.refreshCounter++;
              }

              break;
            case "leave":
              ix = this.joinedChatrooms.findIndex(c => c.chatroom_id == data.chatroom_id);
              if(ix >= 0) {
                chatroom = this.joinedChatrooms[ix];
              } else {
                ix = this.invitedChatrooms.findIndex(c => c.chatroom_id == data.chatroom_id);
                if(ix >= 0) {
                  chatroom = this.invitedChatrooms[ix];
                } 
              }

              if(chatroom != null){
                let uix = chatroom.participants.findIndex(p => p.user_id == data.user_id);
                chatroom.participants.splice(uix, 1);
              }
              this.refreshCounter++;
              break;
            case "kick":
              ix = this.joinedChatrooms.findIndex(c => c.chatroom_id == data.chatroom_id);
              if(ix >= 0) {
                if(data.user_id == this.user.user_id){
                  this.joinedChatrooms.splice(ix, 1);
                }
              } else {
                ix = this.invitedChatrooms.findIndex(c => c.chatroom_id == data.chatroom_id);
                if(ix >= 0) {
                  if(data.user_id == this.user.user_id){
                    this.invitedChatrooms.splice(ix, 1);
                  }
                } 
              }
            
              if(data.chatroom_id == this.selectedChatroom.chatroom_id){
                this.selectedChatroom = null;
              }

              this.refreshCounter++;

              break;
            case "new-message":
              chatroom = this.joinedChatrooms.find(c => c.chatroom_id == data.chatroom_id);
              if(chatroom != null){
                chatroom.chatroom_last_message_user_name = data.participant.user_name;
                chatroom.chatroom_last_message_content = data.content;
                if(data.type == "2" && !chatroom.participants.some(u => u.user_id == data.participant.user_id)){
                  chatroom.participants.push({
                    user_id: data.participant.user_id,
                    user_name: data.participant.user_name,
                    user_background_color: data.participant.user_background_color,
                    user_initials: data.participant.user_initials,
                  })
                }
              }

              this.refreshCounter++;
              break;
          }
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>

.chatroom-container {
  &.fullscreen-mode {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 9999;
    background-color: #fff;
  }

  .chatroom-panels {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: calc(100% - 45px);

    .chatroom-left-panel {
      display: flex;
      flex-direction: column;
      height: 100%;
      min-width: 350px;
      width: 350px;
      max-width: 350px;
      border-right: 1px solid #ccc;

      .chatroom-list-wrapper {
        height: 100%;
        overflow-y: auto;
        width: 100%;
        overflow-x: hidden;

        .chatroom-list-item {
          display: flex;
          flex-direction: row;
          width: 100%;
          border-bottom: 1px solid #ccc;
          
          .chatroom-item-icon {
            border-radius: 100px;
            font-size: 18px;
            background-color: rgb(21, 89, 121);
            color: white;
            text-transform: uppercase;
            padding: 6px;
            height: 37px;
            min-width: 37px;
            width: 37px;
            text-align: center;
          }

          .chatroom-item-title {
            font-size: 12px;
            white-space: nowrap;
          }

          .chatroom-item-last-message {
            font-size: 11px;
            color: #444;
            white-space: nowrap;
          }

          .read-indicator {
            width: 5px;
          }

          &.is-unread {
            .chatroom-item-title {
              color: #356adc;
            }

            .read-indicator {
              background-color: #356adc;
            }
          }

          &:hover, &.selected {
            cursor: pointer;
            background-color: rgb(158, 197, 255);
          }
        }
      }
    }

    .chatroom-right-panel {
      width: auto;
      height: 100%;
      width: 100%;
    }
  }
}

.form-control-title {
  border: none;
  border-bottom: 1px solid rgba(0,0,0,0);
  outline: none;

  &:hover {
    border-bottom: 1px solid #ccc;
  }
}

</style>